const e = {
  listCampaign: {
    schema: {
      method: "get",
      url: "/"
    }
  },
  upsertCampaign: {
    schema: {
      method: "post",
      url: "/",
      mediaType: "application/json"
    }
  }
};
export {
  e as defaultService
};
